import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector, useDecodedToken } from '../app/hooks';

// Gate is UI-only, like the rest of the app's role handling: the token's
// isSuperAdmin claim decides whether to render, but every API call the
// dashboard makes is independently authorized server-side by
// requireSuperAdmin (which re-checks the DB, not the token).
export const SuperAdminRoute = () => {
    const token = useAppSelector((state) => state.auth.token);
    const decodedToken = useDecodedToken();

    if (!token) {
        return <Navigate to="/login" />;
    }

    if (!decodedToken?.isSuperAdmin) {
        return <Navigate to="/activities" />;
    }

    return <Outlet />;
};
